<template>
	<div class="safe-area-bottom"></div>
</template>

<script>
	export default {
		name: "SafeAreaBottom",
	}
</script>

<style scoped lang="scss">
	.safe-area-bottom {
		background: var(--background-color, $backgroundColor);
		position: fixed;
		left: 0;
		right: 0;
		bottom: 0;
		z-index: 99;
		height: var(--safe-area-bottom, 0px);
	}
</style>